import React from 'react'
import styled from 'styled-components'
import { Link } from '@sentecacommerce-theme/lib'
import { LazyImage } from '../../../Common'

export const BrandList = ({ brands }: { brands?: any[] }) => {
  return (
    <>
      {brands?.map((brand: any) => (
        <Container key={`Brand__${brand.slug}`}>
          <Link passHref href={brand.slug}>
            <A aria-label={brand.name}>
              <LazyImage
                src={brand.logo}
                width={150}
                height={150}
                alt={brand.name}
              />
              <Name>{brand.name}</Name>
            </A>
          </Link>
        </Container>
      ))}
    </>
  )
}

const Container = styled.article.attrs({
  className: 'col-6 col-md-2 mb-2',
})``

const Name = styled.div.attrs({
  className: 'd-block',
  'data-blogger': '',
})`
  font-size: 1.6rem;
  text-align: center;
  color: ${({ theme }) => theme.palette.silverTree};
`

const A = styled.a.attrs({
  className: 'd-block p-4',
})`
  height: 100%;

  border-radius: 0.4rem;
  box-shadow: 0 0 0.8rem #e6e5e5;

  transition: box-shadow 0.6s cubic-bezier(0.4, 0, 0.2, 1),
    transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);

  transform: translateY(0);

  &:hover {
    box-shadow: 0 0.5rem 1.6rem rgba(0, 0, 0, 0.15);
    transform: translateY(-0.6rem);
  }
`
